<div class="d-flex justify-content-start   p-4 gap-4">
  <div class="d-flex  "
    [ngClass]="{'line-success':mode=='ADD','line-red':mode=='ERROR','line-warning':mode=='WARNING'}">

  </div>

  <div class="d-inline justify-content-center align-items-center">
    <p class="fs-17 " [ngClass]="{'success':mode=='ADD','error':mode=='ERROR','warning':mode=='WARNING'}">{{title}}!</p>
    <div class="fs-14" [innerHTML]="message"></div>

    <div class="d-flex justify-content-end align-items-center gap-2">

      <div class="border-style d-flex justify-content-center align-items-center">
        <svg (click)="cancel()" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24">
          <path fill="red"
            d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41z"
            stroke-width="0.4" stroke="red" />
        </svg>

      </div>
      <div class="d-flex justify-content-center align-items-center border-style">
        <svg (click)="confirm()" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24">
          <path fill="green"
            d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"
            stroke-width="0.4" stroke="#49d549" />
        </svg>
      </div>


    </div>


  </div>



</div>